//dependencies
import React from "react";

import Breadcrumbs, { Page } from "../../components/Breadcrumbs";
//components
import { Grid, GridCol } from "../../components/Grid";
import Spacer from "../../components/Spacer";

//hooks
import usePageWidthBreakpoint from "../../hooks/usePageWidthBreakpoint";

// templates
import BasePageTemplate from "../BasePageTemplate";
//css
import css from "./FormPageTemplate.module.scss";

type FormPageTemplateProps = {
	/**
	 * Title of the page
	 */
	title?: string;
	/**
	 * Main column elements, accepts list of react nodes
	 */
	mainColumn?: Array<React.ReactNode>;
	/**
	 * Secondary column elements, accepts list of react nodes
	 */
	secondaryColumn?: Array<React.ReactNode>;
	/**
	 * Buttons row, accepts list of react nodes
	 */
	buttonsRow?: Array<React.ReactNode>;

	breadcrumbs?: Array<Page>;
};

const FormPageTemplate: React.FC<FormPageTemplateProps> = ({
	title,
	mainColumn,
	secondaryColumn,
	buttonsRow,
	breadcrumbs,
}) => {
	const { isMobile, isTablet } = usePageWidthBreakpoint();

	//When content width is less than the column withds + gap, we move to stacked mode where the secondary column is stacked above the primary column
	const isStackedView = isMobile || isTablet || !(secondaryColumn && secondaryColumn?.length > 0);

	return (
		<BasePageTemplate title={title} backgroundColor="grey">
			<div className={css.contentContainer}>
				{breadcrumbs && breadcrumbs?.length > 0 ? (
					<div className={`${css.breadcrumbs} ${isStackedView ? css.stackedView : ""}`}>
						<Breadcrumbs pages={breadcrumbs} />
						<Spacer height={2} />
					</div>
				) : (
					<Spacer height={1} />
				)}
				{buttonsRow && buttonsRow?.length > 0 ? (
					<div className={`${css.buttonsRow} ${isStackedView ? css.stackedView : ""}`}>
						{buttonsRow.map((button, index) => (
							<div key={index}>{button}</div>
						))}
					</div>
				) : null}
				<Grid
					cols={isStackedView ? 6 : 8}
					gap={2}
					className={`${css.columnsContainer} ${isStackedView ? css.stackedView : ""}`}
				>
					{secondaryColumn && secondaryColumn?.length > 0 && (
						<GridCol span={isStackedView ? 6 : 2}>
							<div className={css.secondaryColumnContainer}>
								{secondaryColumn.map((element, index) => (
									<div key={index}>{element}</div>
								))}
							</div>
						</GridCol>
					)}
					<GridCol span={6}>
						{mainColumn && mainColumn?.length > 0 && (
							<div className={css.mainColumnContainer}>
								{mainColumn.map((element, index) => (
									<div key={index}>{element}</div>
								))}
							</div>
						)}
					</GridCol>
				</Grid>
			</div>
		</BasePageTemplate>
	);
};

export default FormPageTemplate;
